import PropTypes from 'prop-types';
import { BsPlus } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';

import { renderActivityForm } from './formRegistry';

const ComposerCard = ({ tabs, activeTab, onTabChange, channelsLoading, formProps, getChannelTypeId }) => (
	<Card className="p-0 overflow-hidden">
		<div className="flex items-center gap-1 px-3 pt-2 border-b border-bgBase-500 overflow-x-auto">
			{tabs.map(({ key, label, icon: Icon }) => (
				<button
					key={key}
					type="button"
					onClick={() => onTabChange(activeTab === key ? null : key)}
					className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-medium border-b-2 transition-colors -mb-px whitespace-nowrap ${
						activeTab === key
							? 'border-primary-500 text-primary-600 bg-primary-100/50'
							: 'border-transparent text-bgBase-800 hover:text-text hover:bg-bgBase-300'
					}`}
				>
					<Icon className="w-3.5 h-3.5" />
					{label}
				</button>
			))}
			{channelsLoading && (
				<>
					{[1, 2, 3].map((i) => (
						<div key={i} className="flex items-center gap-1.5 px-3 py-2.5 -mb-px">
							<div className="w-3.5 h-3.5 rounded bg-bgBase-500 animate-pulse" />
							<div className="w-10 h-3 rounded bg-bgBase-500 animate-pulse" />
						</div>
					))}
				</>
			)}
		</div>
		{activeTab ? (
			renderActivityForm({ formType: activeTab, formProps, getChannelTypeId })
		) : (
			<button
				type="button"
				onClick={() => onTabChange(tabs[0]?.key ?? 'activity')}
				className="w-full px-4 py-3.5 text-left text-xs text-bgBase-800 hover:bg-bgBase-300 transition-colors flex items-center gap-1.5"
			>
				<BsPlus className="w-3.5 h-3.5" /> {tabs.map((t) => t.label).join(', ')} hinzufügen …
			</button>
		)}
	</Card>
);

ComposerCard.propTypes = {
	tabs: PropTypes.array.isRequired,
	activeTab: PropTypes.string,
	onTabChange: PropTypes.func.isRequired,
	channelsLoading: PropTypes.bool,
	formProps: PropTypes.object.isRequired,
	getChannelTypeId: PropTypes.func.isRequired,
};

export default ComposerCard;
